@if (loading | async) {
    <div class="spinner-container d-flex justify-content-center align-items-center">
        <mat-spinner></mat-spinner>
    </div>
} @else {
    <div class="p-2">
        <h1 mat-dialog-title>Update Reservation Data</h1>
        <div mat-dialog-content [formGroup]="editImportDataForm">
            <div class="row mt-2">
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>Reservation Ref ID</mat-label>
                        <input matInput placeholder="Reservation Reference ID" formControlName="reservation_reference_id">
                    </mat-form-field>
                </div>
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>Policy ID</mat-label>
                        <input matInput placeholder="Policy ID" formControlName="policy_id">
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>Property Reference ID</mat-label>
                        <input matInput placeholder="Property Reference ID" formControlName="property_reference_id">
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>Property Name</mat-label>
                        <input matInput placeholder="Property Name" formControlName="property_name">
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>Arrival Date</mat-label>
                        <input matInput [matDatepicker]="arrival_picker" formControlName="arrival_date" [max]="departureDateValue">
                        <mat-error *ngIf="editImportDataForm.get('arrival_date')?.hasError('matDatepickerMax')">Arrival date must be before Departure date</mat-error>
                        <mat-datepicker-toggle matSuffix [for]="arrival_picker"></mat-datepicker-toggle>
                        <mat-datepicker #arrival_picker></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>Departure Date</mat-label>
                        <input matInput [matDatepicker]="departure_picker" formControlName="departure_date" [min]="arrivalDateValue">
                        <mat-error *ngIf="editImportDataForm.get('departure_date')?.hasError('matDatepickerMin')">Departure date must be after Arrival date</mat-error>
                        <mat-datepicker-toggle matSuffix [for]="departure_picker"></mat-datepicker-toggle>
                        <mat-datepicker #departure_picker></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>Booking Date</mat-label>
                        <input matInput [matDatepicker]="booking_picker" formControlName="booking_date" >
                        <mat-datepicker-toggle matSuffix [for]="booking_picker"></mat-datepicker-toggle>
                        <mat-datepicker #booking_picker></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>Reservation Cost (USD)</mat-label>
                        <input matInput placeholder="Reservation Cost" formControlName="reservation_cost">
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>Guest's Name</mat-label>
                        <input matInput placeholder="Guest Name" formControlName="guest">
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>Owner's Name</mat-label>
                        <input matInput placeholder="Owner's Name" formControlName="owner">
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>Address</mat-label>
                        <input matInput placeholder="Address" formControlName="property_address">
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>City</mat-label>
                        <input matInput placeholder="City" formControlName="city">
                    </mat-form-field>
                </div>
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>State</mat-label>
                        <input matInput placeholder="State" formControlName="state">
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>Postal Code</mat-label>
                        <input matInput placeholder="Postal Code" formControlName="postal_code">
                    </mat-form-field>
                </div>
                <div class="col d-flex flex-column"></div>
            </div>
        </div>
        <mat-dialog-actions class="my-2 d-flex justify-content-end">
            <button mat-raised-button class="cancel-button" (click)="onCancelClick()">
                <mat-icon>cancel</mat-icon>
                Cancel
            </button>
            <button mat-raised-button class="action-button" (click)="onSaveChangesClick()">
                <mat-icon>check</mat-icon>
                Save Changes
            </button>
        </mat-dialog-actions>
    </div>
}